import { Graphics, Point } from 'pixi.js';
import { Vector2 } from 'three';
import { Dimensioning } from '../../core/dimensioning';

// class that handle the rendering for the 
// temporary wall items
export class TemporaryWallItem extends Graphics {
    constructor() {
        super();
        this.wallitemColour = 0xFF0000;
        this.wallItemWidth = 50;
        this.wallItemDepth = 10;
    }

    setType(type) {
        if (type == "door") {
            this.wallitemColour = 0xFF0000;
            this.wallItemWidth = 50;
            this.wallItemDepth = 10;
        } else if (type == "window") {
            this.wallitemColour = 0xFF0000;
            // this.wallItemWidth = 120;
            this.wallItemDepth = 20;
        }
    }

    setDimensions(width, height) {
        this.wallItemWidth = width / 2;
        //this.wallItemDepth = height/2;
    }

    __toPixels(vector) {
        vector.x = Dimensioning.cmToPixel(vector.x);
        vector.y = Dimensioning.cmToPixel(vector.y);
        return vector;
    }

    update(point, wall) {
        this.clear();
        this.lineStyle(0, 0xF0F0F0);

        let wallDirection = wall.wallDirectionNormalized();
        // default width/depth for a newly created door
        // let width = 50;
        // let depth = 10;
        let right = wallDirection.clone().multiplyScalar(this.wallItemWidth);
        let left = wallDirection.clone().multiplyScalar(this.wallItemWidth).multiplyScalar(-1);
        let up = wallDirection.clone().rotateAround(new Vector2(), Math.PI * 0.5).multiplyScalar(this.wallItemDepth);
        let down = up.clone().multiplyScalar(-1);

        let a = point.clone().add(right.clone().add(up));
        let b = point.clone().add(right.clone().sub(up));
        let c = point.clone().add(left.clone().add(down));
        let d = point.clone().add(left.clone().sub(down));

        let points = [
            new Point(Dimensioning.cmToPixel(a.x), Dimensioning.cmToPixel(a.y)),
            new Point(Dimensioning.cmToPixel(b.x), Dimensioning.cmToPixel(b.y)),
            new Point(Dimensioning.cmToPixel(c.x), Dimensioning.cmToPixel(c.y)),
            new Point(Dimensioning.cmToPixel(d.x), Dimensioning.cmToPixel(d.y)),
        ];

        this.beginFill(this.wallitemColour, 0.50);
        this.drawPolygon(points);
        this.endFill();
    }
}
